<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a toggle that allows users to turn push notifications on and off
    *
    * @since 20210504
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2021 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <span>
        <!---<span v-if="shouldDisplay">
            <div class="custom-control custom-switch m-2">
                <input type="checkbox" class="custom-control-input" id="notificationsOnid" name="notificationsOnid" v-model="notificationsOn" @change="updateState">
                <label v-if="saving" class="custom-control-label" for="notificationsOnid"><i class="fas fa-sync fa-spin"></i> Toggling Notifications</label>
                <label v-else class="custom-control-label" for="notificationsOnid">Notifications On/Off</label>
            </div>
        </span>
        <span v-if="failed" class="text-danger">
            Notifications Off <tool-tip text="Your browser does not support push notifications. If you would like to receive push notifications, please try a different browser."/>
        </span>--->
    </span>
</template>

<script>
    import firebase from "firebase/app";
    import "firebase/messaging";
    export default{
        props: {
            saveRoute: {
                type: String,
                default: ''
            },
            removeRoute: {
                type: String,
                default: ''
            },
            currentTokens: {
                type: Array,
            },
        },
        created() {
            var self = this;
            if ('serviceWorker' in navigator && 'PushManager' in window) {            
                // always initialise to install the service worker
                // Initialize the Firebase app in the service worker by passing in
                // your app's Firebase config object.
                // https://firebase.google.com/docs/web/setup#config-object
                firebase.initializeApp({
                    apiKey: "AIzaSyBYMiqS5xRwpSaXluquQ75Y3nw3wegD9UU",
                    authDomain: "collsys-push-notifications.firebaseapp.com",
                    projectId: "collsys-push-notifications",
                    storageBucket: "collsys-push-notifications.appspot.com",
                    messagingSenderId: "568300907424",
                    appId: "1:568300907424:web:928d73e21bbdbdd62fd2c5",
                    measurementId: "G-8461YVYKLE"
                });
               
                navigator.serviceWorker.register('/service_worker.js').then(function(registration) {
                    self.serviceReg = registration;
                    self.shouldDisplay = true;
                    console.log(self.serviceReg);
                    if(self.currentTokensActual.length > 0){
                        self.getToken(function(currentToken){
                            if(self.currentTokensActual.includes(currentToken)){
                                self.notificationsOn = true;
                            }
                        }); 
                    }
                }).catch((error) => {
                    self.failed = true;
                    self.shouldDisplay = false;
                    console.log('An error occurred loading the service worker');
                    if(error.response !== undefined){
                        console.log('File: ' + error.response.data.file);
                        console.log('Line: ' + error.response.data.line);
                        console.log('Message: ' + error.response.data.message);
                        console.log('Exception: ' + error.response.data.exception);
                        console.log(error.response.data.trace);
                    } else {
                        console.log(error);
                    }
                }); 
            } else {
                this.failed = true;
                this.shouldDisplay = false;
            }
            self.cacheOfflinePages();
        },
        data() {
            return {
                deferredPrompt: null,
                shouldDisplay: false,
                failed: false,
                saving: false,
                addedToHomePage: false,
                currentTokensActual: this.currentTokens,
                notificationsOn: false,
                serviceReg: null
            }
        },
        computed: {
        },
        methods: {
            updateState: function(){
                var self = this;
                self.saving = true;
                console.log(self.notificationsOn);
                if(self.notificationsOn){
                    self.install();
                } else {
                    self.getToken(function(currentToken){
                        self.removeToken(currentToken);
                    });
                }
            },
            getToken: function(getFunc=null) {
                var self = this;
                console.log(self.serviceReg);
                if(self.serviceReg !== null){
                    // Retrieve an instance of Firebase Messaging so that it can handle background messages.
                    const messaging = firebase.messaging();
                    messaging.getToken({ vapidKey: 'BI7QlCcOku6zf_aQ0zTnDIUK4pandLTp5YVsLf3oXJmAk9lntyjIwX05QxxZ1SFGnyvfGuDZxwb6dXfhO5hOsdw', serviceWorkerRegistration : self.serviceReg }).then((currentToken) => {
                        if (currentToken) {
                            //localStorage.setItem("firebase_message_token", currentToken);
                            if(getFunc !== null){
                                getFunc(currentToken);
                            } else {
                                self.saving = false;
                                self.notificationsOn = false;
                            }
                        } else {
                            // Show permission request UI
                            console.log('No registration token available. Request permission to generate one.');
                            // ...
                            self.saving = false;
                            self.notificationsOn = false;
                        }
                    }).catch((err) => {
                        console.log('An error occurred while retrieving token. ', err);
                        // ...
                        self.saving = false;
                        self.notificationsOn = false;
                    });
                } else {
                    self.saving = false;
                    self.notificationsOn = false;
                }
            },
            /**
             * saves the announcement modal
             */
            saveToken: function (token){
                var self = this;
                var type = 'put';
                var save_params = {
                    token: token
                };
                this.$http[type](
                    this.saveRoute, 
                    save_params
                ).then(function (response) {
                    if(!self.error_occured){
                        if(response.data.error !== undefined){
                            self.error_occured = true;
                            self.notificationsOn = false;
                            console.log('An error occurred saving the token');
                            console.log(response.data.error);
                        } else {
                            console.log(response.data);
                            self.currentTokensActual = response.data;
                            self.saving = false;
                        }
                    } else {
                        self.error_occured = true;
                        self.notificationsOn = false;
                    }
                }).catch((error) => {
                    self.error_occured = true;
                    self.notificationsOn = false;
                    console.log('An error occurred saving the token');
                    if(error.response !== undefined){
                        console.log('File: ' + error.response.data.file);
                        console.log('Line: ' + error.response.data.line);
                        console.log('Message: ' + error.response.data.message);
                        console.log('Exception: ' + error.response.data.exception);
                        console.log(error.response.data.trace);
                    } else {
                        console.log(error);
                    }
                }).then(function () {
                    self.saving = false;
                });
            },
            /**
             * saves the announcement modal
             */
            removeToken: function (token){
                var self = this;
                var type = 'delete';
                var save_params = {
                    token: token
                };
                this.$http[type](
                    this.removeRoute, 
                    {data: save_params}
                ).then(function (response) {
                    if(!self.error_occured){
                        if(response.data.error !== undefined){
                            self.error_occured = true;
                            console.log('An error occurred deleting the token');
                            console.log(response.data.error);
                        } else {
                            console.log(response.data);
                            const messaging = firebase.messaging();
                            messaging.deleteToken().then(() => {
                                console.log('Token deleted.');
                            }).catch((err) => {
                                console.log('Unable to delete token. ', err);
                            });
                            self.currentTokensActual = response.data;
                            self.saving = false;
                        }
                    } else {
                        self.error_occured = true;
                    }
                }).catch((error) => {
                    self.error_occured = true;
                    
                    console.log('An error occurred deleting the token');
                    if(error.response !== undefined){
                        console.log('File: ' + error.response.data.file);
                        console.log('Line: ' + error.response.data.line);
                        console.log('Message: ' + error.response.data.message);
                        console.log('Exception: ' + error.response.data.exception);
                        console.log(error.response.data.trace);
                    } else {
                        console.log(error);
                    }
                }).then(function () {
                    self.saving = false;
                });
            },
            install: function(){
                this.saving = true;
                var self = this;
                Notification.requestPermission().then((result) => {
                    console.log(result);
                    if (result === 'granted') {
                        // hide our user interface that shows our A2HS button
                        self.getToken(function(currentToken){
                            self.saveToken(currentToken);
                        });
                    } else {
                        self.saving = false;
                        self.notificationsOn = false;
                    }
                }).catch((error) => {
                    console.log('An error occurred loading the user choice');
                    if(error.response !== undefined){
                        console.log('File: ' + error.response.data.file);
                        console.log('Line: ' + error.response.data.line);
                        console.log('Message: ' + error.response.data.message);
                        console.log('Exception: ' + error.response.data.exception);
                        console.log(error.response.data.trace);
                    } else {
                        console.log(error);
                    }
                    self.saving = false;
                    self.notificationsOn = false;
                });
                
            },
            cacheOfflinePages: function(){
                if(navigator.onLine)
                {
                    if ('serviceWorker' in navigator) 
                    {
                        //add offline home to cache to show when offline
                        caches.open('we_offline_cache').then(function(cache) {
                            fetch('/homeOffline', {timeout: 300000}).then(function(response) {
                                // /get-article-urls returns a JSON-encoded array of
                                // resource URLs that a given article depends on
                                return response;
                            }).then(function(urls) {
                                cache.put('/homeOffline', urls);
                            }).catch((error) => {
                                console.log('An error occurred loading the fetch');
                                if(error.response !== undefined){
                                    console.log('File: ' + error.response.data.file);
                                    console.log('Line: ' + error.response.data.line);
                                    console.log('Message: ' + error.response.data.message);
                                    console.log('Exception: ' + error.response.data.exception);
                                    console.log(error.response.data.trace);
                                } else {
                                    console.log(error);
                                }
                            });
                        }).catch((error) => {
                            console.log('An error occurred loading the cache');
                            if(error.response !== undefined){
                                console.log('File: ' + error.response.data.file);
                                console.log('Line: ' + error.response.data.line);
                                console.log('Message: ' + error.response.data.message);
                                console.log('Exception: ' + error.response.data.exception);
                                console.log(error.response.data.trace);
                            } else {
                                console.log(error);
                            }
                        });
                    }
                }
            }
        }
    }
</script>